import angular from 'angular';

import MatchDirective, { selector } from './match.directive';

export default angular
    .module('application.directive.match', [])
    .directive(selector, MatchDirective);



// WEBPACK FOOTER //
// ./src/application/directive/match/index.js